import { render, staticRenderFns } from "./ProductSetEdit.vue?vue&type=template&id=064fa811&scoped=true&"
import script from "./ProductSetEdit.vue?vue&type=script&lang=js&"
export * from "./ProductSetEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetEdit.vue?vue&type=style&index=0&id=064fa811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fa811",
  null
  
)

export default component.exports